"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAppendCTA = void 0;
var _CTAentryPoints = _interopRequireDefault(require("../../components/CTAentryPoints"));
var _constants = require("../../utils/constants");
var _react = _interopRequireWildcard(require("react"));
var _reactDom = require("react-dom");
var _r10SourceLibrary = require("r10-source-library");
var _styledComponents = require("styled-components");
var _globals = _interopRequireDefault(require("../../components/vfuk/globals"));
var _useConfig = _interopRequireDefault(require("../useConfig"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const useAppendCTA = () => {
  _r10SourceLibrary.themeWS10.globalStyles = _globals.default;
  const enableShadowDOM = (0, _useConfig.default)('enableShadowDOM', false);
  const entryPointArray = (0, _react.useMemo)(() => {
    const nodeArray = [];
    if (enableShadowDOM) {
      const entryNodes = document.querySelectorAll(`div[id *= '${_constants.APP_ROOT_ID}']`);
      entryNodes.forEach(node => {
        var _node$shadowRoot;
        let shadowAppRoot = node.shadowRoot;
        let shadowAppContainer = (_node$shadowRoot = node.shadowRoot) === null || _node$shadowRoot === void 0 ? void 0 : _node$shadowRoot.getElementById(_constants.APP_SHADOW_DOM_ROOT_CONTAINER_ID);
        if (!shadowAppRoot) {
          shadowAppRoot = node.attachShadow({
            mode: 'open'
          });

          // styles container
          const styleSlot = document.getElementById(_constants.APP_ROOT_ID).shadowRoot.getElementById(_constants.APP_SHADOW_DOM_STYLES_SLOT_ID).cloneNode(true);
          shadowAppRoot.appendChild(styleSlot);
          shadowAppContainer = document.createElement('div');
          shadowAppContainer.id = _constants.APP_SHADOW_DOM_ROOT_CONTAINER_ID;
          shadowAppRoot.appendChild(shadowAppContainer);
          nodeArray.push(() => /*#__PURE__*/(0, _reactDom.createPortal)( /*#__PURE__*/_react.default.createElement(_styledComponents.StyleSheetManager, {
            target: styleSlot
          }, /*#__PURE__*/_react.default.createElement("div", {
            className: _constants.APP_ROOT_ID
          }, /*#__PURE__*/_react.default.createElement(_CTAentryPoints.default, null))), shadowAppContainer));
        } else {
          nodeArray.push(() => /*#__PURE__*/(0, _reactDom.createPortal)( /*#__PURE__*/_react.default.createElement("div", {
            className: _constants.APP_ROOT_ID
          }, /*#__PURE__*/_react.default.createElement(_CTAentryPoints.default, null)), shadowAppContainer));
        }
      });
    }
    return nodeArray;
  }, []);
  return entryPointArray;
};
exports.useAppendCTA = useAppendCTA;